/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type models_InvoiceDueDateRule = {
    /**
     * DayOfMonth of the billing month, read by day_of_billing_month (1-28).
     */
    day_of_month?: number;
    /**
     * Days after the invoice date, read by days_after_invoice (1-90).
     */
    days?: number;
    /**
     * Minimum days between invoice date and due date in the period-based modes
     * (0-30). 0 keeps the due date on or after the invoice date. Absent reads 10.
     */
    floor_days?: number;
    mode: models_InvoiceDueDateRule.mode;
};
export namespace models_InvoiceDueDateRule {
    export enum mode {
        DAYS_AFTER_INVOICE = 'days_after_invoice',
        LAST_DAY_OF_PREVIOUS_MONTH = 'last_day_of_previous_month',
        DAY_OF_BILLING_MONTH = 'day_of_billing_month',
        LAST_DAY_OF_BILLING_MONTH = 'last_day_of_billing_month',
    }
}

